<template>
  <div>
    <emat-block :name="$t('global.word.installation_supplies')" v-if="fetchedCategories.length > 0">
      <emat-block-item style="padding: 0;">
        <EmatCategory
          v-for="category in fetchedCategories"
          :key="category.id"
          :label="category.name"
          :image="category.image_url"
          :menu="openProductModal"
          :totalProducts="category.products"
          :class="device"
          :infoPopup="category.info_popup"
          @showPopup="
              openProductModal = true;
              currentCategory = category;
            "
        />
      </emat-block-item>
    </emat-block>

    <ProductsBlockPopup
        @close="currentCategory = null"
        v-if="currentCategory"
        :product-category="currentCategory"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import EmatBlock from 'Components/Layout/Block';
import EmatBlockItem from 'Components/Layout/BlockItem';
import EmatPopup from 'Components/Layout/Popup';
import EmatCategory from 'Components/Layout/ProductCategory';
import EmatProduct from 'Components/Layout/Product';
import ProductsBlockPopup from '@/components/configuration/ProductsBlockPopup';

export default {
  name: 'ProductsBlock',
  components: {
    ProductsBlockPopup,
    EmatBlock,
    EmatBlockItem,
    EmatPopup,
    EmatCategory,
    EmatProduct,
  },
  data() {
    return {
      openProductModal: false,
      currentCategory: null,
      selectedProducts: [],
    };
  },

  computed: {
    ...mapGetters('products', [
      'getAllByCategoryId',
    ]),
    ...mapGetters({
      type: 'types/current',
      categories: 'categories/getAllCategories',
      productState: 'products/getAll',
      device: 'getDevice',
      methods: 'methods/all',
      allProducts: 'products/getAll',
    }),
    ...mapState('build', ['method']),

    availableProductIds() {
      const method = this.methods.find(method => {
        return method.id === this.method;
      });

      return method.products.map(product => product.id);
    },

    fetchedCategories() {
      return this.categories
        .map(category => {
          return {
            ...category,
            products: category.products.filter(product => {
              return this.availableProductIds.findIndex(id => id === product.id) !== -1;
            }),
          };
        })
        .filter(category => {
          return category.products.length > 0;
        });
    },
  },
};
</script>

<style lang="scss">
.product-modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 11px 15px;
  box-shadow: $box-shadow-small;

  .text {
    font-size: 12px;
    font-family: $font;
  }
}
</style>
